import { render, staticRenderFns } from "./SchoolSearch.vue?vue&type=template&id=ce9edef6&"
import script from "./SchoolSearch.vue?vue&type=script&lang=ts&"
export * from "./SchoolSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolSearch.vue?vue&type=style&index=0&id=ce9edef6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports